<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Permite confirmar una operación</p>
    <f7-row>
      <f7-col
        class="display-flex justify-content-center margin-top margin-bottom"
        width="100"
      >
        <f7-button
          fill
          color="green"
          @click="UCConfirmationCreateAndShow()"
        >
          Crear una confirmación
        </f7-button>
      </f7-col>
    </f7-row>
    <UCConfirmation ref="UCConfirmation" />
  </f7-block>
</template>

<script>
import UCConfirmation from '@/components/common/UCConfirmation.vue';

export default {
  name: 'TestUCConfirmation',
  components: {
    UCConfirmation,
  },
  methods: {
    UCConfirmationCreateAndShow() {
      this.$refs.UCConfirmation.create(
        'Eliminar marcaje trabajador',
        'El marcaje seleccionado del trabajador será eliminado de forma permanente. ¿Estás seguro que quieres eliminar el marcaje?',
        this.RemoveWorkerRecords,
      );
      this.$refs.UCConfirmation.show();
    },
  },
};
</script>
